/* istanbul ignore file */
import { pip } from './pages/pip/pip';
import { pep } from './pages/pep/pep';
import { browseAndCategory } from './pages/browseAndCategory/browseAndCategory';
import { search } from './pages/search/search';
import { collections } from './pages/collections/collections';
import { compare } from './pages/compare/compare';
import { packages } from './pages/packages/packages';
import { giftcards } from './pages/giftcards/giftcards';
import { myPreferenceCenter } from './pages/myPreferenceCenter/myPreferenceCenter';
import { exerciseMyPrivacyRights } from './pages/exerciseMyPrivacyRights/exerciseMyPrivacyRights';
import { seoExperience } from './pages/seo-experience/seo-experience';
import { optOut } from './pages/optOut/optOut';
import { promotions } from './pages/promotions/promotions';
import { buyItAgain } from './pages/buyItAgain/buyItAgain';
import { pathToProNetwork } from './pages/pathToProNetwork/pathToProNetwork';
import { articleExperience } from './pages/article/article';
import { articleListingPage } from './pages/articleListingPage/articleListingPage';
import { localAd } from './pages/localAd/localAd';
import { content } from './pages/content/content';
import { projectCalculators } from './pages/projectCalculators/projectCalculators';
import { landingPage } from './pages/landingPage/landingPage';
import { creditCenter } from './pages/creditCenter/creditCenter';
import { storeFinder } from './pages/store-finder/store-finder';
import { rebateCenter } from './pages/rebate-center/rebate-center';
import { workshops } from './pages/workshops/workshops';
import { selfService } from './pages/self-service/self-service';
import { myHomepage } from './pages/myHomepage/myHomepage';
import { myList } from './pages/myList/myList';
import {
  communicationPreferences
} from './pages/communicationPreferences/communicationPreferences';
import { colorWall } from './pages/colorWall/colorWall';

export const page = () => {
  seoExperience();
  browseAndCategory();
  pep();
  search();
  collections();
  compare();
  packages();
  giftcards();
  optOut();
  promotions();
  pip();
  exerciseMyPrivacyRights();
  communicationPreferences();
  myPreferenceCenter();
  buyItAgain();
  pathToProNetwork();
  articleExperience();
  articleListingPage();
  localAd();
  content();
  projectCalculators();
  landingPage();
  creditCenter();
  storeFinder();
  rebateCenter();
  workshops();
  selfService();
  myHomepage();
  myList();
  colorWall();
};
